import React, { useState, useEffect } from "react";
import { saveWeddingInfo, getWeddingInfo } from "../firebase";
import { WeddingInfo } from "../types/wedding";

const MessageManagement: React.FC = () => {
  const [weddingInfo, setWeddingInfo] = useState<Partial<WeddingInfo>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeddingInfo = async () => {
      try {
        const data = await getWeddingInfo();
        if (data) {
          setWeddingInfo(data);
        }
      } catch (error) {
        console.error("Error fetching wedding info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWeddingInfo();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setWeddingInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (Object.keys(weddingInfo).length === 0) {
      alert("No data to save.");
      return;
    }
    try {
      // Fetch the full wedding info to not overwrite other fields
      const fullWeddingInfo = await getWeddingInfo();
      const updatedInfo = { ...fullWeddingInfo, ...weddingInfo };

      await saveWeddingInfo(updatedInfo);
      alert("저장되었습니다.");
    } catch (error) {
      console.error("Error saving wedding info:", error);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container py-4">
      <h2 className="text-center mb-4">초대 문구 관리</h2>
      <form onSubmit={handleSubmit}>
        <div className="card mb-4">
          <div className="card-header">
            <h3 className="card-title mb-0">문구 설정</h3>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label className="form-label">
                Hero 섹션 부제 (메인 제목 아래 문구)
              </label>
              <textarea
                name="parallaxSubtitle"
                value={weddingInfo.parallaxSubtitle || ""}
                onChange={handleChange}
                className="form-control"
                rows={3}
                placeholder="소중한 분들을 초대합니다."
              />
            </div>
            <div className="mb-3">
              <label className="form-label">초대장 메시지</label>
              <textarea
                name="invitationMessage"
                value={weddingInfo.invitationMessage || ""}
                onChange={handleChange}
                className="form-control"
                rows={6}
                placeholder="서로가 마주보며 다져온 사랑을..."
              />
            </div>
          </div>
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary btn-lg">
            저장
          </button>
        </div>
      </form>
    </div>
  );
};

export default MessageManagement;
